export default function initExpandableTextBlocks() {
    document.querySelectorAll('.expandable-text').forEach(expandable => {
        expandable.querySelectorAll('.expandable-text-trigger').forEach(trigger => {
            trigger.addEventListener('click', () => {
                const content = expandable.querySelector('.expandable-text-content');

                if (expandable.classList.contains('open')) {
                    content.style.height = 0 + 'px';
                    expandable.classList.remove('open');
                } else {
                    content.style.height = expandable.scrollHeight + 'px';
                    expandable.classList.add('open');
                }
            });
        });
    });
}
